<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <g>
                    <g>
                        <g>
                            <path class="fill" d="M.226 8.5c-.062 0-.12-.025-.164-.07C.02 8.387-.003 8.327 0 8.266c.069-1.447.495-2.678 1.268-3.66.618-.785 1.455-1.409 2.49-1.855.503-.217 1.329-.507 2.406-.655.372-.05.671-.07.862-.078V.225c0-.087.05-.166.128-.203.079-.037.172-.026.24.028l4.522 3.642c.053.042.084.106.084.173 0 .068-.03.132-.082.175L7.395 7.777c-.067.056-.16.068-.24.03-.079-.036-.13-.115-.13-.202v-1.95c-1.134-.08-2.178.003-3.107.25-.782.207-1.484.53-2.087.96C.813 7.589.433 8.365.43 8.372.39 8.45.313 8.5.226 8.5z" transform="translate(-397.000000, -324.000000) translate(321.000000, -0.000000) translate(64.000000, 324.000000) translate(11.999950, 0.000000) translate(0.000000, 2.000000) translate(6.000000, 4.250000) scale(-1, 1) translate(-6.000000, -4.250000)"/>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
